import { Component } from '@angular/core';
import { RoutesService } from '@abp/ng.core';
import { eThemeBasicComponents } from '@abp/ng.theme.basic';
import { eThemeSharedRouteNames, NavItemsService } from '@abp/ng.theme.shared';

@Component({
  selector: 'app-root',
  standalone: false,
  template: `
    <abp-loader-bar></abp-loader-bar>
    <abp-layout-application></abp-layout-application>
  `
})
export class AppComponent {
  constructor(
    private routes: RoutesService,
    private navItems: NavItemsService
  ) {
    this.routes.patch(eThemeSharedRouteNames.Administration, {
      invisible: true
    });
    this.navItems.removeItem(eThemeBasicComponents.CurrentUser);
  }
}
